import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiModel } from './api.model';

export type NewsArticleMediaKind = 'image' | 'gif' | 'video';

export type NewsArticleMedia = {
    kind: NewsArticleMediaKind;
    url: string;
};

/** A published article in the requested language. The backend already filters by the viewer's audience. */
export type NewsFeedArticle = {
    id: string;
    title: string;
    body: string;
    media: NewsArticleMedia | null;
    recipients: Array<'retailer' | 'manufacturer'>;
    created: string;
    updated: string;
};

/**
 * Paginated shape returned by the `/internal/news/:feedLanguage` endpoint when the
 * `enable_newsfeed_v2` flag is on. When the flag is off, the same endpoint returns the legacy
 * S3 feed as a bare array instead, so callers must check which shape they received.
 */
export type NewsFeedPage = {
    articles: NewsFeedArticle[];
    nextCursor: string | null;
};

@Injectable()
export class NewsModel {
    constructor(private apiModel: ApiModel) {}

    getNews(data: { language: string; cursor?: string; limit?: number }): Observable<NewsFeedArticle[] | NewsFeedPage> {
        const params: Record<string, string> = {};
        if (data.cursor) {
            params.cursor = data.cursor;
        }
        if (data.limit) {
            params.limit = String(data.limit);
        }
        return this.apiModel.makeHttpObservableRequest({
            method: 'GET',
            params,
            url: `${this.apiModel.getNewsEndpoint()}/${data.language}`
        });
    }
}
